import { useContext, useState } from 'react';

import { IoMdClose } from 'react-icons/io';

import { BoletoView } from '../ViewsMenu/BoletoView';
import { CreditCardView } from '../ViewsMenu/CreditCardView';
import { PixView } from '../ViewsMenu/PixView';

import styles from './PurchaseMenu.module.scss';
import { CheckoutContext } from '@/context/Checkout';
import { showToast } from '@/components/atoms/Toast/Toast';
import { axiosInstance } from '@/utils/axiosInstance';
import { navigate } from '@/utils/navigate';
import { Loading } from '@/components/atoms';
import { useRouter } from 'next/router';

let showAppButton: boolean;

export const PurchaseMenu = ({
  appButton,
  origin,
  paymentCards,
  isCreditCardMpActive = false,
  isPixMpActive = false,
  userState = '',
  isPagaLeveActive,
  userInfo,
}) => {
  const router = useRouter();

  const { checkoutData } = useContext(CheckoutContext);
  const activeBundle = checkoutData.bundlesData.find(
    (bundle) => bundle.nameId === checkoutData.currentBundleName
  );

  const [currentOption, setCurrenteOption] = useState('card');
  const [loading, setLoading] = useState<boolean>(false);
  const [pagaleveWebviewUrl, setPagaleveWebviewUrl] = useState<string | null>(
    null
  );
  const viewOption = {
    pix: (
      <PixView
        appButton={appButton}
        origin={origin}
        isMercadoPago={isPixMpActive}
        userState={userState}
      />
    ),
    card: (
      <CreditCardView
        appButton={appButton}
        origin={origin}
        paymentCards={paymentCards}
        isMercadoPago={isCreditCardMpActive}
        userState={userState}
      />
    ),
    boleto: <BoletoView origin={origin} userState={userState} />,
    pagaleve: loading && (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 200,
        }}
      >
        <Loading />
      </div>
    ),
  };

  const handleRedirectPagaleve = async () => {
    setCurrenteOption('pagaleve');
    setLoading(true);
    try {
      setCurrenteOption('pagaleve');
      const url = router.asPath;

      const callback_approve_url = `https://www.getninjas.com.br${url}`;

      const requestOptions = {
        method: 'POST',
        url: `${process.env.NEXT_PUBLIC_API_PRO}/purchase/pix_pagaleve`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          userInfo,
          activeBundle,
          callback_approve_url,
        },
      };

      const { data } = await axiosInstance(requestOptions);

      setLoading(false);
      if (origin === 'webcheckout-ios') {
        setPagaleveWebviewUrl(data.checkoutUrl);
      } else {
        navigate(data.checkoutUrl);
      }
    } catch (error) {
      setLoading(false);
      showToast({
        message: error.response.data.clientMessage,
        type: 'error',
      });
    }
  };

  return (
    <>
      {pagaleveWebviewUrl && (
        <div className={styles['pagaleve__webview__overlay']}>
          <div className={styles['pagaleve__webview__header']}>
            <button
              className={styles['pagaleve__webview__close']}
              onClick={() => setPagaleveWebviewUrl(null)}
              type="button"
            >
              <IoMdClose size={24} />
            </button>
          </div>
          <iframe
            src={pagaleveWebviewUrl}
            className={styles['pagaleve__webview__iframe']}
            title="Pagaleve"
          />
        </div>
      )}
      <div className={`purchase__menu ${styles['purchase__menu']}`}>
        <button
          className={`menu__item ${styles['menu__item']} ${
            currentOption === 'card' ? styles.active : ''
          } `}
          onClick={() => setCurrenteOption('card')}
        >
          <p>Cartão</p>
          <span>Até 3x</span>
        </button>

        <button
          className={`menu__item ${styles['menu__item']} ${
            currentOption === 'pix' ? styles.active : ''
          } `}
          onClick={() => setCurrenteOption('pix')}
        >
          <p>Pix</p>
          <span>à vista</span>
        </button>

        <button
          className={`menu__item ${styles['menu__item']} ${
            currentOption === 'boleto' ? styles.active : ''
          } `}
          onClick={() => setCurrenteOption('boleto')}
        >
          <p>Boleto</p>
          <span>à vista</span>
        </button>

        {isPagaLeveActive && (
          <button
            className={`menu__item ${styles['menu__item']} ${
              currentOption === 'pagaleve' ? styles.active : ''
            } `}
            onClick={handleRedirectPagaleve}
          >
            <p>Pagaleve</p>
            <span>pix parc.</span>
          </button>
        )}
      </div>
      <div
        className={`purchase__option__view ${styles['purchase__option__view']}`}
      >
        {viewOption[currentOption]}
      </div>
    </>
  );
};
